import { createAsyncThunk } from '@reduxjs/toolkit';
import { DashboardStats } from '../../types';
import { DashboardApi } from '../../services/end-points';
import { ThunkConfig } from '../configure-store';

export const getDashboardStats = createAsyncThunk<DashboardStats, { year?: number } | void, ThunkConfig>(
    'dashboard/getStats',
    async (params, thunkAPI) => {
        try {
            const response = await DashboardApi.getStats(params || undefined);
            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.response?.data?.message || 'Failed to fetch dashboard stats');
        }
    },
);
